import useQueryParams from 'hooks/useQueryParams';
import { useEffect } from 'react'
import { useHistory } from 'react-router';
import { CASUALITY_GENERAL } from '../constantes';

const PagoCasualityGenerales = () => {

    const history = useHistory();
    const { id = '' } = useQueryParams();

    useEffect(() => {
        history.replace(`${CASUALITY_GENERAL.urls.contratante}?idPoliza=${id}`);
        history.push(`/pago?idPoliza=${id}&codProducto=${CASUALITY_GENERAL.codProducto}`);
    }, [history, id]);

    return null;

}
export default PagoCasualityGenerales;
